const csrf = (): string => document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || "";

export interface JsonResult {
  ok: boolean;
  data: Record<string, any>;
}

export async function sendJson(url: string, method: string, body: BodyInit, json = true): Promise<JsonResult> {
  const headers: Record<string, string> = { Accept: "application/json", "X-CSRF-Token": csrf() };
  if (json) headers["Content-Type"] = "application/json";
  try {
    const response = await fetch(url, { method, headers, body });
    const data = await response.json().catch(() => ({}));
    return { ok: response.ok && data.success !== false, data };
  } catch (_e) {
    return { ok: false, data: { message: "Network error, try again" } };
  }
}

export function replaceRow(id: string, html: string | undefined): void {
  if (!html) return;
  const row = document.querySelector(`tr.customer-row[data-id="${id}"]`);
  if (!row) return;
  const template = document.createElement("template");
  template.innerHTML = html.trim();
  const fresh = template.content.firstElementChild;
  if (fresh) row.replaceWith(fresh);
  (window as any).mountLogos?.();
}
